// extracted by mini-css-extract-plugin
module.exports = {"slide":"list_slide_-thlw","slide-reverse":"list_slide-reverse_3E1Jg","table":"list_table_3DZJC"};